import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function Dashboard(): React.ReactElement {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.50391 11.6875H0.664062C0.297301 11.6875 0 11.9848 0 12.3516V16.3359C0 16.7027 0.297301 17 0.664062 17H7.50391C7.87067 17 8.16797 16.7027 8.16797 16.3359V12.3516C8.16797 11.9848 7.87067 11.6875 7.50391 11.6875ZM6.83984 15.6719H1.32812V13.0156H6.83984V15.6719Z" />
      <path d="M7.50391 0H0.664062C0.297301 0 0 0.297301 0 0.664062V10.3594C0 10.7261 0.297301 11.0234 0.664062 11.0234H7.50391C7.87067 11.0234 8.16797 10.7261 8.16797 10.3594V0.664062C8.16797 0.297301 7.87067 0 7.50391 0ZM6.83984 9.69531H1.32812V1.32812H6.83984V9.69531Z" />
      <path d="M16.3359 0H9.49609C9.12933 0 8.83203 0.297301 8.83203 0.664062V4.64844C8.83203 5.0152 9.12933 5.3125 9.49609 5.3125H16.3359C16.7027 5.3125 17 5.0152 17 4.64844V0.664062C17 0.297301 16.7027 0 16.3359 0ZM15.6719 3.98438H10.1602V1.32812H15.6719V3.98438Z" />
      <path d="M16.3359 5.97656H9.49609C9.12933 5.97656 8.83203 6.27386 8.83203 6.64062V16.3359C8.83203 16.7027 9.12933 17 9.49609 17H16.3359C16.7027 17 17 16.7027 17 16.3359V6.64062C17 6.27386 16.7027 5.97656 16.3359 5.97656ZM15.6719 15.6719H10.1602V7.30469H15.6719V15.6719Z" />
    </svg>
  );
}

